import { render, staticRenderFns } from "./IdleStage.vue?vue&type=template&id=bff51002"
import script from "./IdleStage.vue?vue&type=script&lang=ts"
export * from "./IdleStage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports